<template>
  <div class="container">
    <div class="authorization-container">
      <SiteLogo/>
      <AuthorizationForm v-if="tabIndex === LoginTabId" v-on:authenticated="onSuccessAuth" ref="authForm" />
      <!-- <RestorePasswordForm v-else-if="tabIndex === RestorePasswordTabId" v-on:authenticated="onSuccessAuth" />
      <div v-if="tabIndex === LoginTabId" class="link-tabs">
        <a class="link" href="#" @click="showTab(RestorePasswordTabId)">забыли пароль?</a>
      </div>
      <div v-if="tabIndex === RestorePasswordTabId" class="link-tabs">
        <a class="link" href="#" @click="showTab(LoginTabId)">Войти</a>
      </div> -->
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import AppLogo from '../components/AppLogo';
import AuthorizationForm from '../components/IdentityForms/AuthorizationForm';
import RestorePasswordForm from '../components/IdentityForms/RestorePasswordForm';

export default {
  components: {
    AppLogo,
    AuthorizationForm,
    RestorePasswordForm
  },
  data: () => ({
    tabIndex: 0,
    LoginTabId: 0,
    RestorePasswordTabId: 2,
  }),
  methods: {
    addClass(el, className) {
      if (el.classList) {
        el.classList.add(className);
      } else if (!this.hasClass(el, className)) {
        el.className += ` ${className}`;
      }
    },
    removeClass(el, className) {
      if (el.classList) {
        el.classList.remove(className);
      } else if (this.hasClass(el, className)) {
        const reg = new RegExp(`(\\s|^)${className}(\\s|$)`);
        el.className = el.className.replace(reg, ' ');
      }
    },
    hasClass(el, className) {
      if (el.classList) {
        return el.classList.contains(className);
      }
      return !!el.className.match(new RegExp(`(\\s|^)${className}(\\s|$)`));
    },
    onSuccessAuth(data) {
      this.$root.$emit('authenticated', data);
      if (this.hasClass(document.body, 'login')) {
        this.removeClass(document.body, 'login');
      }
    },
    showTab(tabIndex) {
      this.tabIndex = tabIndex;
      switch (tabIndex) {
        case this.LoginTabId:
          document.title = 'Авторизация';
          break;
        case this.RestorePasswordTabId:
          document.title = 'Восстановление доступа';
          break;
      }
    },
  },
  created() {
    if (this.$store.getters.isAuthenticated) {
      window.location.href = '/';
      return;
    }
    this.$store.dispatch('setGuest', false);
    if (!this.hasClass(document.body, 'login')) {
      this.addClass(document.body, 'login');
    }
  },
  beforeDestroy() {
    if (this.hasClass(document.body, 'login')) {
      this.removeClass(document.body, 'login');
    }
  },
};
</script>

<style scoped src='../assets/css/authorization.css'>
</style>
